import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSelling = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M2.463 2.463A1.233 1.233 0 0 1 1.23 1.23 1.235 1.235 0 0 1 2.463 0H29.54a1.232 1.232 0 0 1-.003 2.463h-1.232v2.462a2.462 2.462 0 0 1 2.463 2.463v9.846a2.462 2.462 0 0 1-2.463 2.463H11.078a2.462 2.462 0 0 1-2.462-2.462v-9.85a2.462 2.462 0 0 1 2.462-2.463v-2.46H6.153V30.77c0 .677-.553 1.23-1.231 1.23s-1.228-.553-1.228-1.231V2.463zm11.075 2.459h12.306v-2.46H13.538z" clipRule="evenodd" /></svg>;
export default SvgSelling;